import { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import PeerPulse from '@/components/molecules/PeerPulse';
import { background, text } from '@/theme/colors/palettes';

/**
 * Shared page wrapper for the weekly report and its loading, error, expired,
 * and submitted states. Provides the light-blue, full-height background,
 * PeerPulse branding, and centered content with responsive padding.
 */
const WeeklyReportContainer = ({ children }: { children: ReactNode }) => {
  return (
    <Box as="main" w="100%" minH="100dvh" bg={background.lightBlue} color={text.mediumBlue} px={8} pb={12}>
      <PeerPulse />
      <Box maxW="610px" mx="auto">
        {children}
      </Box>
    </Box>
  );
};

export default WeeklyReportContainer;
